


































import { defineComponent, ref, watch } from '@vue/composition-api';
import AdClient from '@/bundles/Ad/models/AdClient';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import { VForm } from '@/bundles/App/type';
import { IAdClient } from '@/bundles/Ad/interfaces';

export default defineComponent({
  name: 'AdClientFormBase',

  emits: ['item:submit'],

  props: {
    adClientEntry: {
      type: AdClient,
      required: true,
    },
    saveLoadingEntry: Boolean,
    isEditForm: Boolean,
  },

  setup (props, { emit }) {
    const adClientForm = ref(null);
    const { adClient } = useAdClient();

    function resetValidation () {
      if (!adClientForm.value) {
        return;
      }
      (adClientForm.value as unknown as VForm).resetValidation();
    }
    watch(() => props.adClientEntry, function () {
      adClient.value = { ...props.adClientEntry };
      resetValidation();
    }, { deep: true, immediate: true });
    function submitEventHandler () {
      if (!(adClientForm.value as unknown as VForm).validate()) {
        return;
      }
      const payload: Partial<IAdClient> = {
        name: adClient.value.name,
      };
      if (props.isEditForm) {
        payload.id = adClient.value.id;
        payload.active = adClient.value.active;
      }
      emit('item:submit', payload);
    }

    return {
      adClient,
      adClientForm,
      submitEventHandler,
    };
  },
});
